import { fetchWarehouseMultiProductReporting } from "../../../services/warehouse.services";
import i18n from "../../../i18n";

export const handleBulkForcasting = async (
  Products,
  selectedRows,
  setForcastingLoader,
  setProducts,
  setSnack,
) => {
  const selectedProducts =
    Products?.data?.filter((product) => selectedRows.includes(product.id)) ||
    [];

  if (!selectedProducts.length) {
    return;
  }

  setForcastingLoader(true);

  try {
    // Get only product_warehouse records that don't already
    // have forecasting data
    const productWarehouses = selectedProducts.flatMap((product) => {
      // Product has children → forecast children only
      if (product?.children?.length) {
        return (
          product.children.flatMap(
            (child) =>
              child?.product_warehouse?.filter(
                (warehouse) => !warehouse?.productforcasting,
              ) || [],
          ) || []
        );
      }

      // Product has no children → forecast parent
      return (
        product?.product_warehouse?.filter(
          (warehouse) => !warehouse?.productforcasting,
        ) || []
      );
    });

    // Everything already has forecasting
    if (!productWarehouses.length) {
      setSnack((snack) => ({
        ...snack,
        open: true,
        text: i18n.t("inventory:products.allHaveForecasts"),
        severity: "warning",
      }));
      return;
    }

    // Single multi-forecast API call
    const response = await fetchWarehouseMultiProductReporting({
      product_warehouse_ids: productWarehouses.map((warehouse) => warehouse.id),
    });

    if (response?.error || !response?.data?.result) {
      throw new Error("Failed to fetch forecasting data");
    }

    const forecastMap = response.data.result;

    // Update Products
    setProducts((prevProducts) => ({
      ...prevProducts,

      data: prevProducts?.data?.map((product) => {
        // Product has children
        if (product?.children?.length) {
          return {
            ...product,

            // Parent forecast is not required
            children: product.children.map((child) => ({
              ...child,

              product_warehouse: child?.product_warehouse?.map((warehouse) => {
                if (!forecastMap?.[warehouse.id]) {
                  return warehouse;
                }

                return {
                  ...warehouse,
                  productforcasting: forecastMap[warehouse.id],
                };
              }),
            })),
          };
        }

        // Product has no children → update parent
        return {
          ...product,

          product_warehouse: product?.product_warehouse?.map((warehouse) => {
            if (!forecastMap?.[warehouse.id]) {
              return warehouse;
            }

            return {
              ...warehouse,
              productforcasting: forecastMap[warehouse.id],
            };
          }),
        };
      }),
    }));
  } catch (error) {
    console.error("Bulk forecasting error:", error);

    setSnack((snack) => ({
      ...snack,
      open: true,
      text: i18n.t("inventory:products.forecastsError"),
      severity: "error",
    }));
  } finally {
    setForcastingLoader(false);
  }
};
